export default "__VITE_ASSET__BN2stT0u__"